/**
 * Socket service - facade over SocketManager for backward compatibility.
 * New code should use SocketManager directly for connection state and forceReconnect.
 */

import { socketManager } from './SocketManager';

export const initSocket = (token) => socketManager.init(token);
export const getSocket = () => socketManager.getSocket();
export const disconnectSocket = () => socketManager.disconnect();
export const isSocketConnected = () => socketManager.isConnected();

// Re-export for consumers that need production-grade APIs
export { socketManager, ConnectionState } from './SocketManager';
